import { FREE_TEXT_COUNTER_START, FREE_TEXT_MAX_LENGTH } from '@fyf/shared';

interface CharacterCounterProps {
  current: number;
}

export function CharacterCounter({ current }: CharacterCounterProps) {
  if (current < FREE_TEXT_COUNTER_START) return null;

  const remaining = FREE_TEXT_MAX_LENGTH - current;
  const isOver = remaining < 0;

  return (
    <p
      className={`text-sm mt-1 text-right ${isOver ? 'text-red-400' : 'text-gray-300'}`}
      aria-live="polite"
    >
      {remaining} characters remaining
    </p>
  );
}
